import * as React from 'react';
// import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';

import AccountCircle from '@mui/icons-material/AccountCircle';
import MoreIcon from '@mui/icons-material/MoreVert';
import Icon from '@mui/material/Icon';
import './styles.css';

import logo from '../../imagenes/logo.png';

// const Search = styled('div')(({ theme }) => ({
//   position: 'relative',
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: alpha(theme.palette.common.white, 0.15),
//   '&:hover': {
//     backgroundColor: alpha(theme.palette.common.white, 0.25),
//   },
//   marginRight: theme.spacing(2),
//   marginLeft: 0,
//   width: '100%',
//   [theme.breakpoints.up('sm')]: {
//     marginLeft: theme.spacing(3),
//     width: 'auto',
//   },
// }));

// const SearchIconWrapper = styled('div')(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: '100%',
//   position: 'absolute',
//   pointerEvents: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: 'inherit',
//   '& .MuiInputBase-input': {
//     padding: theme.spacing(1, 1, 1, 0),
//     // vertical padding + font size from searchIcon
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create('width'),
//     width: '100%',
//     [theme.breakpoints.up('md')]: {
//       width: '20ch',
//     },
//   },
// }));

export default function PrimarySearchAppBar(props) {
  const {Config} = props; 
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {props.User ? <MenuItem 
                      onClick={()=>{
                        props.Login()
                        handleMenuClose()
                      }}
                    >Salir</MenuItem>
        :<div>
          <MenuItem onClick={()=>{
                        if (props.Login) props.Login()
                        handleMenuClose()
                      }}
          >Iniciar</MenuItem>
          <MenuItem onClick={()=>{
                                  if(props.Registro) props.Registro()
                                  handleMenuClose()
                                }
                              }
          >
            Registrarse
          </MenuItem>
        </div>
      }
      
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {Config.Menu_iconos.map((val,i)=>
        <MenuItem key={`menu-icono-r-${i}`}>
          <IconButton size="large" color="inherit" title={val.title}>
            <Badge badgeContent={0} color="error">
              <Icon >shopping_cart</Icon>
            </Badge>
          </IconButton>
          <p>{val.title}</p>
        </MenuItem>
      )}
      
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Perfil</p>
      </MenuItem>
    </Menu>
  );
  let persona=''
  if (props){
    if (props.User){
      // persona+=props.User.username;
      if(props.User.api==='wesi_chs_server'){
        const lista = props.Config.Listas.lista_categoria;
        persona=lista[props.User.categoria].titulo;
      }else{
        const lista = props.Config.Listas[`lista_${props.User.api}_categoria`];
        if(lista){
          persona=lista[props.User.categoria].titulo;
        }else{
          persona='AdminitradorCHS'
        }
        
      }
      
    }

  }
    
  return (
      <Box>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(props.open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          { !props.open ? <img  src={Config.Logo ? Config.Logo : logo}  className={'logo'} 
                                style={{height:60, width:60, ...Config.Estilos.Logo ? Config.Estilos.Logo : {} }} 
                                alt="logo" 
                          /> 
                        : null}
          {/* <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Búsqueda…"
              inputProps={{ 'aria-label': 'search' }}
              onChange={props.Buscar ? props.Buscar : (value)=>console.log('Buscar =>',value.target.value)}
            />
          </Search> */}
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
           {Config.Titulo ? Config.Titulo : 'CHS +'}
           
          </Typography>
          <MenuItem sx={{marginLeft:2 ,backgroundColor:'#000', opacity:0.6, borderRadius:2}}>
            <Typography variant="h6" textAlign="center" >{props.Seleccion ? props.Seleccion : 'Inicio'}</Typography>
          </MenuItem>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems:'center' }}>
            <Typography
              variant="subtitle"
              noWrap
              component="div"
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              
              {persona}
            </Typography>
            {Config.Menu_iconos.map((val,i)=>
              <IconButton size="large" color="inherit" key={`menu-icono-${i}`} title={val.title} onClick={()=>props.Seleccion_pantalla(val.value)}>
                <Badge badgeContent={0} color="error">
                  <Icon >shopping_cart</Icon>
                </Badge>
              </IconButton>
            )}
            

            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
        {renderMobileMenu}
        {renderMenu}
      </Box>
  );
}
